export enum TimeTrackingTypeEnum {
    Ordinary = 0,
    Extraordinary = 1
}

